import { render, staticRenderFns } from "./yek-terveyskeskuskoulutusjaksot-card.vue?vue&type=template&id=a725d844&scoped=true&"
import script from "./yek-terveyskeskuskoulutusjaksot-card.vue?vue&type=script&lang=ts&"
export * from "./yek-terveyskeskuskoulutusjaksot-card.vue?vue&type=script&lang=ts&"
import style0 from "./yek-terveyskeskuskoulutusjaksot-card.vue?vue&type=style&index=0&id=a725d844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a725d844",
  null
  
)

export default component.exports